import React from 'react'
import { Text } from 'react-native'

interface ErrorMessageProps {
  message?: string | null
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null
  return <Text style={{ color: 'red', marginTop: 8 }}>{message}</Text>
}

export default ErrorMessage
